import { openSnackBarAction } from 'context/reducers/openSnackbarReducer'
import { getFromApi, postToApi, putToApi } from '.'
import { VALUES } from 'utils/constants'

const { TABLE_DATA_INTIAL_STATE } = VALUES

export async function registerAction(
   url,
   payload,
   cleanForm,
   setTableData,
   dispatch
) {
   const registeredData = await postToApi(url, payload)
   cleanForm()
   setTableData({
      ...TABLE_DATA_INTIAL_STATE,
      data: [registeredData]
   })
   dispatch(
      openSnackBarAction(`Se guardó ${registeredData.name} correctamente.`, 'info')
   )
   return registeredData
}

export async function searchAction(
   url,
   searchPayloadSchema,
   cleanForm,
   setTableData,
   externalFilters = null,
   filtersState,
   pagingFromTableParams = null,
   paginationState
) {
   const [searchFilters, setSearchFilters] = filtersState
   const [paginationParams, setPaginationParams] = paginationState
   const filters = externalFilters ?? searchFilters
   const paginationFilters = { ...paginationParams, ...pagingFromTableParams }
   setSearchFilters(filters)
   setPaginationParams(paginationFilters)
   const data = {}
   if (searchPayloadSchema && searchPayloadSchema.length) {
      searchPayloadSchema.forEach(searchFilter => {
         if (filters[searchFilter]) {
            data[searchFilter] = filters[searchFilter]
         }
      })
   } else {
      data = { ...filters }
   }
   const payload = { ...data, ...paginationFilters }
   const searchedData = await getFromApi(url, payload)
   setTableData(searchedData)
   cleanForm()
}

export async function editAction(
   url,
   payload,
   cleanForm,
   setTableData,
   dispatch
) {
   const editedData = await putToApi(url, payload)
   cleanForm()
   setTableData({
      ...TABLE_DATA_INTIAL_STATE,
      data: [editedData]
   })
   dispatch({
      type: 'OPEN_SNACKBAR',
      openMessage: {
         message: `Se editó ${editedData.name} correctamente.`,
         severity: 'info'
      }
   })
}
